import * as React from 'react';

import { translate } from '~l10n/client';

interface Props {
  team: {
    name: string;
    completePercentage: number;
    color: string;
    secondaryColor: string;
  };
  teamCount: number;
  iconType: string;
}

function getSize(teamCount: number) {
  let size = '';

  if (teamCount < 15) {
    size = 'large';
  }
  if (teamCount < 12) {
    size = 'larger';
  }
  if (teamCount < 9) {
    size = 'largest';
  }
  if (teamCount < 6) {
    size = 'x_large';
  }
  return size;
}

export function TeamRocket({ team, teamCount, iconType }: Props) {
  const { name, completePercentage, color, secondaryColor } = team;
  const size = getSize(teamCount);

  return (
    <div className={'rocket-wrap ' + size}>
      <div className="team-color-row">{translate(name)}</div>
      <div className="progress-wrapper">
        <div className="rocket-path-row">
          <div
            className="progress-color-row"
            style={{
              width: completePercentage * 100 + '%',
              backgroundColor: color,
              borderLeft: '0.3em solid ' + secondaryColor,
            }}
          >
            <div
              className="team-icon"
              // Make sure the teams icons don't breach the space race container.
              // This overrides the 'right' rule in css for .team-icon.
              style={{ right: completePercentage > 0.9 ? 0 : null }}
            >
              <img
                src={`${window.APP_CONFIG.STATIC_URL}${window.APP_CONFIG.VERSION}/img/space-race/${iconType}-large.png`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
